import { ConnectionQuality, Track, } from 'livekit-client';
import { toast } from 'react-toastify';
import { store } from '../../store';
import i18n from '../i18n';
import { addParticipant, participantsSelector, removeParticipant, updateParticipant, } from '../../store/slices/participantSlice';
import { updateCurrentUserMetadata, updateScreenSharing, } from '../../store/slices/sessionSlice';
import { updateIsActiveParticipantsPanel, updateIsActiveRaisehand, } from '../../store/slices/bottomIconsActivitySlice';
import { removeOneSpeaker } from '../../store/slices/activeSpeakersSlice';
import { updatePlayAudioNotification } from '../../store/slices/roomSettingsSlice';
import { sendAnalyticsByWebsocket } from '../websocket';
import { AnalyticsEvents, AnalyticsEventType, } from '../proto/plugnmeet_analytics_pb';
import languages from '../languages';
export default class HandleParticipants {
    constructor(that) {
        this.isRecorderJoin = false;
        this.participantsCount = 0;
        this.participantCounterInterval = 0;
        this.lastConnectionQuality = undefined;
        this.preferredLang = '';
        this.participantConnected = (participant) => {
            this.addParticipant(participant);
        };
        this.addParticipant = (participant) => {
            var _a, _b, _c;
            let metadata = null;
            if (participant.metadata) {
                try {
                    metadata = JSON.parse(participant.metadata);
                    if (metadata) {
                        this.notificationForWaitingUser(metadata, participant.name);
                    }
                }
                catch (e) { }
            }
            // set default metadata to prevent errors
            if (!metadata) {
                metadata = {
                    is_admin: false,
                    is_presenter: false,
                    raised_hand: false,
                    wait_for_approval: false,
                    lock_settings: {
                        lock_microphone: true,
                        lock_webcam: true,
                        lock_screen_sharing: true,
                        lock_chat: true,
                        lock_chat_send_message: true,
                        lock_chat_file_share: true,
                        lock_private_chat: true,
                        lock_whiteboard: true,
                        lock_shared_notepad: true,
                    },
                };
            }
            let videoTracksCount = 0, audioTracksCount = 0, screenShareTrackCount = 0, isMuted = false;
            participant.getTracks().forEach((t) => {
                if (t.source === Track.Source.Camera) {
                    videoTracksCount += 1;
                }
                else if (t.source === Track.Source.Microphone) {
                    audioTracksCount += 1;
                    isMuted = t.isMuted;
                }
                else if (t.source === Track.Source.ScreenShare ||
                    t.source === Track.Source.ScreenShareAudio) {
                    screenShareTrackCount = 1;
                }
            });
            store.dispatch(addParticipant({
                sid: participant.sid,
                userId: participant.identity,
                name: (_a = participant.name) !== null && _a !== void 0 ? _a : '',
                metadata: metadata,
                audioTracks: audioTracksCount,
                videoTracks: videoTracksCount,
                screenShareTrack: screenShareTrackCount,
                isMuted: isMuted,
                connectionQuality: participant.connectionQuality,
                isLocal: false,
                joinedAt: (_c = (_b = participant.joinedAt) === null || _b === void 0 ? void 0 : _b.getTime()) !== null && _c !== void 0 ? _c : Date.now(),
                visibility: 'visible',
            }));
            if (this.isRecorderJoin) {
                this.participantsCount++;
            }
        };
        this.participantDisconnected = (participant) => {
            this.removeParticipant(participant);
            if (this.isRecorderJoin) {
                this.participantsCount--;
            }
        };
        this.removeParticipant = (p) => {
            const participant = participantsSelector.selectById(store.getState(), p.identity);
            if (participant === null || participant === void 0 ? void 0 : participant.screenShareTrack) {
                store.dispatch(updateScreenSharing({
                    isActive: false,
                    sharedBy: '',
                }));
            }
            // now remove user.
            store.dispatch(removeParticipant(p.identity));
            // remove if in active speaker
            store.dispatch(removeOneSpeaker(p.identity));
            // now remove webcam
            this.that.updateVideoSubscribers(p, false);
            // now remove audio
            this.that.updateAudioSubscribers(p, false);
            // check for screen sharing
            this.that.updateScreenShareOnUserDisconnect(p);
        };
        this.connectionQualityChanged = (connectionQuality, participant) => {
            store.dispatch(updateParticipant({
                id: participant.identity,
                changes: {
                    connectionQuality: connectionQuality,
                },
            }));
            if (connectionQuality === ConnectionQuality.Poor ||
                connectionQuality === ConnectionQuality.Lost) {
                if (participant.sid === this.that.room.localParticipant.sid &&
                    !(participant.identity === 'RECORDER_BOT' ||
                        participant.identity === 'RTMP_BOT')) {
                    let msg = i18n.t('notifications.your-connection-quality-not-good');
                    if (connectionQuality === ConnectionQuality.Lost) {
                        msg = i18n.t('notifications.your-connection-quality-lost');
                    }
                    toast(msg, {
                        toastId: 'connection-status',
                        type: 'error',
                    });
                }
            }
            // send analytics
            if (participant.identity === this.that.room.localParticipant.identity) {
                if (this.lastConnectionQuality !== connectionQuality) {
                    this.lastConnectionQuality = connectionQuality;
                    sendAnalyticsByWebsocket(AnalyticsEvents.ANALYTICS_EVENT_USER_CONNECTION_QUALITY, AnalyticsEventType.USER, connectionQuality.toString());
                }
            }
        };
        this.setParticipantMetadata = async (_, participant) => {
            if (participant.metadata) {
                const metadata = JSON.parse(participant.metadata);
                store.dispatch(updateParticipant({
                    id: participant.identity,
                    changes: {
                        metadata,
                    },
                }));
                if (this.that.room.localParticipant.sid === participant.sid) {
                    if (this.preferredLang === '' &&
                        typeof metadata.preferred_lang !== 'undefined' &&
                        metadata.preferred_lang !== '') {
                        this.preferredLang = metadata.preferred_lang;
                        for (let i = 0; i < languages.length; i++) {
                            const lan = languages[i];
                            if (lan.code.toLowerCase() === metadata.preferred_lang.toLowerCase()) {
                                // we'll only change if we've found the right language
                                await i18n.changeLanguage(lan.code);
                                break;
                            }
                        }
                    }
                    store.dispatch(updateCurrentUserMetadata(metadata));
                    store.dispatch(updateIsActiveRaisehand(metadata.raised_hand));
                }
            }
        };
        this.that = that;
    }
    recorderJoined() {
        this.isRecorderJoin = true;
        this.startParticipantCounter();
        //store.dispatch(updateIsActiveChatPanel(false));
        store.dispatch(updateIsActiveParticipantsPanel(false));
    }
    clearParticipantCounterInterval() {
        if (this.participantCounterInterval) {
            clearInterval(this.participantCounterInterval);
        }
    }
    /*
     * startParticipantCounter will only call if participant was a recorder or RTMP bot
     * */
    startParticipantCounter() {
        this.participantCounterInterval = setInterval(() => {
            if (this.participantsCount === 0) {
                console.log('NO_USER_ONLINE');
                this.that.room.disconnect();
            }
        }, 3000);
    }
    notificationForWaitingUser(metadata, name) {
        var _a, _b, _c;
        const state = store.getState();
        if ((_a = state.session.currentUser) === null || _a === void 0 ? void 0 : _a.isRecorder) {
            // if current user is recorder then don't need to do anything
            return;
        }
        if (metadata.wait_for_approval &&
            ((_c = (_b = state.session.currentUser) === null || _b === void 0 ? void 0 : _b.metadata) === null || _c === void 0 ? void 0 : _c.is_admin)) {
            // we can open participants panel if close
            if (!state.bottomIconsActivity.isActiveParticipantsPanel) {
                store.dispatch(updateIsActiveParticipantsPanel(true));
            }
            // also play notification
            store.dispatch(updatePlayAudioNotification(true));
            toast(i18n.t('waiting-room.user-waiting', {
                name: name,
            }), {
                type: 'info',
                toastId: 'user-waiting',
            });
        }
    }
}
